/* Channel Canna: Spin the can (sections/channel-label.liquid). No deps.
   Draws the real label wrap onto a canvas as a cylinder: the visible half
   of the can is sliced into vertical strips, each sampling the wrap at its
   angle, so the print curves away at the edges like a real can. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Spin(root) {
    this.root = root;
    this.cans = [].slice.call(root.querySelectorAll('[data-spin-can]')).map(function (fig) {
      var c = fig.querySelector('canvas');
      return { fig: fig, canvas: c, ctx: c.getContext('2d'), img: null };
    });
    this.ritual = 'joe';
    this.rot = 0.17;            /* fraction of the wrap at the centre of the can */
    this.target = null;
    this.vel = 0;
    this.drag = null;
    this.zoom = 1; this.zoomTo = 1;   /* label stops (except Front) move in close */
    this.loaded = false;
    this.gl = null;
    var self = this;
    var src = root.getAttribute('data-three');
    if (src && window.WebGLRenderingContext && !this.gl) {
      /* Shopify's asset minifier rewrites import() into require(), so the
         ES module is pulled in through an injected module script instead. */
      var start = function (create) {
        var apis = self.cans.map(function (can) {
          return create(can.fig.querySelector('.spin__body'), function () { can.fig.classList.add('is-3d'); });
        });
        if (apis.every(Boolean)) { self.gl = apis; self.loaded = false; if (self.visible) self.load(); }
      };
      if (window.__ccCan3D) start(window.__ccCan3D);
      else {
        document.addEventListener('cc:can3d', function () { try { start(window.__ccCan3D); } catch (e) {} }, { once: true });
        var inject = function () {
          if (document.querySelector('script[data-can3d]')) return;
          var sc = document.createElement('script');
          sc.type = 'module'; sc.setAttribute('data-can3d', '');
          sc.textContent = "import { createCan3D } from '" + src.replace(/'/g, '') + "'; window.__ccCan3D = createCan3D; document.dispatchEvent(new Event('cc:can3d'));";
          document.head.appendChild(sc);
        };
        /* Speed pass (2026-10-09, Lighthouse F3): three.js (~170 KB) used to
           load with the home page. The section sits far down the page, so
           fetch it only once the section is within ~2.5 screens. The 2D can
           draws first exactly as before (it waits for 300px), and the 3D
           can replaces it when it arrives, as it already did. */
        /* Review fix: the 3D can sets a different body aspect ratio (.4 vs
           .37) and fades over the 2D one, so it must be ready before the
           section is reached, as it was when it loaded with the page. Real
           visitors start it on their first scroll or input (still ~8
           sections away); the near-viewport observer stays as a backstop.
           A load with no input at all (Lighthouse) never fetches it. */
        var evs = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];
        var near = null;
        var kick = function () {
          evs.forEach(function (t) { window.removeEventListener(t, kick, true); });
          if (near) near.disconnect();
          inject();
        };
        evs.forEach(function (t) { window.addEventListener(t, kick, { capture: true, passive: true }); });
        if (window.IntersectionObserver) {
          near = new IntersectionObserver(function (en) {
            if (en.some(function (x) { return x.isIntersecting; })) kick();
          }, { rootMargin: '250% 0px' });
          near.observe(root);
        } else kick();
      }
    }

    root.addEventListener('click', function (e) {
      var r = e.target.closest('[data-spin-ritual]');
      if (r) { self.setRitual(r.getAttribute('data-spin-ritual')); return; }
      var s = e.target.closest('[data-spin-to]');
      if (s) {
        var first = self.root.querySelector('[data-spin-to]') === s;
        self.zoomTo = first || reduce ? 1 : 1.75;
        [].forEach.call(self.root.querySelectorAll('[data-spin-to]'), function (b) { b.setAttribute('aria-pressed', String(b === s)); });
        self.root.classList.toggle('is-zoomed', self.zoomTo > 1);
        self.turnTo(parseFloat(s.getAttribute('data-spin-to')) / 100);
      }
    });
    this.cans.forEach(function (can) {
      var el = can.fig.querySelector('.spin__body');
      el.addEventListener('pointerdown', function (e) {
        self.drag = { x: e.clientX, rot: self.rot, t: performance.now() };
        self.target = null; self.vel = 0;
        if (self.zoomTo !== 1) { self.zoomTo = 1; self.root.classList.remove('is-zoomed'); }
        el.setPointerCapture(e.pointerId);
        root.classList.add('is-dragging');
      });
      el.addEventListener('pointermove', function (e) {
        if (!self.drag) return;
        var w = el.clientWidth || 300;
        var dx = e.clientX - self.drag.x;
        var prev = self.rot;
        self.rot = self.drag.rot - dx / (w * Math.PI);
        var now = performance.now();
        self.vel = (self.rot - prev) / Math.max(16, now - self.drag.t) * 16;
        self.drag.t = now;
        self.draw();
      });
      var up = function () { self.drag = null; root.classList.remove('is-dragging'); self.loop(); };
      el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', up);
    });

    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { self.load(); self.visible = true; self.loop(); }
      else self.visible = false;
    }, { rootMargin: '300px 0px' });
    io.observe(root);
    window.addEventListener('resize', function () { if (self.gl) self.gl.forEach(function (g) { g.resize(); }); else self.size(); self.draw(); });
  }

  Spin.prototype.setRitual = function (r) {
    this.ritual = r;
    [].forEach.call(this.root.querySelectorAll('[data-spin-ritual]'), function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-spin-ritual') === r));
    });
    this.loaded = false; this.load();
  };

  Spin.prototype.load = function () {
    if (this.loaded) return;
    this.loaded = true;
    var self = this;
    if (this.gl) {
      this.cans.forEach(function (can, i) { self.gl[i].resize(); self.gl[i].setLabel(can.fig.getAttribute('data-' + self.ritual)); });
      return;
    }
    this.size();
    this.cans.forEach(function (can) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { can.img = img; self.draw(); };
      img.src = can.fig.getAttribute('data-' + self.ritual);
    });
  };

  Spin.prototype.size = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.cans.forEach(function (can) {
      var b = can.canvas.getBoundingClientRect();
      if (!b.width) return;
      can.canvas.width = Math.round(b.width * dpr);
      can.canvas.height = Math.round(b.height * dpr);
    });
  };

  Spin.prototype.turnTo = function (f) {
    var d = ((f - this.rot) % 1 + 1.5) % 1 - 0.5;  /* shortest way round */
    if (reduce) { this.rot += d; this.draw(); return; }
    this.target = this.rot + d; this.vel = 0; this.loop();
  };

  Spin.prototype.loop = function () {
    if (this.raf) return;
    var self = this;
    var step = function () {
      self.raf = null;
      if (self.drag) return;
      var moving = false;
      if (Math.abs(self.zoomTo - self.zoom) > 0.001) { self.zoom += (self.zoomTo - self.zoom) * 0.14; moving = true; }
      else self.zoom = self.zoomTo;
      if (self.target !== null) {
        var d = self.target - self.rot;
        if (Math.abs(d) < 0.0005) { self.rot = self.target; self.target = null; }
        else { self.rot += d * 0.12; moving = true; }
      } else if (Math.abs(self.vel) > 0.00005) {
        self.rot += self.vel; self.vel *= 0.94; moving = true;
      } else if (!reduce && self.visible && self.zoomTo === 1) {
        self.rot += 0.0004; moving = true;     /* slow idle turn (holds still while zoomed in) */
      }
      self.draw();
      if (moving && self.visible) self.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
  };

  function metal(ctx, W, a, b) {
    var g = ctx.createLinearGradient(0, 0, W, 0);
    g.addColorStop(0, '#4f4940'); g.addColorStop(.14, '#9d978b'); g.addColorStop(.36, '#f4f1eb');
    g.addColorStop(.52, '#c8c2b7'); g.addColorStop(.84, '#878175'); g.addColorStop(1, '#46403a');
    return g;
  }

  /* Real 12oz sleek can: tapered shoulder + lid with tab on top, label body,
     short inward chime + domed base below. Shading only lands on the can. */
  Spin.prototype.draw = function () {
    var rot = this.rot, z = this.zoom;
    this.root.style.setProperty('--spin-zoom', z.toFixed(3));
    if (this.gl) { this.gl.forEach(function (g) { if (g.zoom) g.zoom(z); g.render(rot); }); return; }
    this.cans.forEach(function (can) {
      var img = can.img, ctx = can.ctx, W = can.canvas.width, H = can.canvas.height;
      if (!img || !W) return;
      ctx.clearRect(0, 0, W, H);
      var ry = W * 0.1, inset = W * 0.09, neckY = ry + H * 0.004;
      var lt = Math.round(H * 0.088), lb = Math.round(H * 0.948);
      var g = metal(ctx, W);
      /* label body */
      var iw = img.naturalWidth, ih = img.naturalHeight, N = 72;
      for (var i = 0; i < N; i++) {
        var a0 = -Math.PI / 2 + Math.PI * i / N, a1 = a0 + Math.PI / N;
        var x0 = (Math.sin(a0) + 1) / 2 * W, x1 = (Math.sin(a1) + 1) / 2 * W;
        var dw = x1 - x0; if (dw <= 0.2) continue;
        var u = rot + (a0 + Math.PI / 2) / (2 * Math.PI) - 0.25;
        u = ((u % 1) + 1) % 1;
        var sx = u * iw, sw = iw / (2 * N);
        if (sx + sw > iw) sx = iw - sw;
        ctx.drawImage(img, sx, 0, sw, ih, x0, lt, dw + 0.6, lb - lt);
      }
      /* shoulder */
      var sh = lt - neckY;
      ctx.beginPath();
      ctx.moveTo(0, lt + 1);
      ctx.bezierCurveTo(0, lt - sh * 0.6, inset, neckY + sh * 0.3, inset, neckY);
      ctx.lineTo(W - inset, neckY);
      ctx.bezierCurveTo(W - inset, neckY + sh * 0.3, W, lt - sh * 0.6, W, lt + 1);
      ctx.closePath(); ctx.fillStyle = g; ctx.fill();
      /* lid: rim, recessed panel, tab */
      var rx = W / 2 - inset;
      ctx.beginPath(); ctx.ellipse(W / 2, neckY, rx, ry, 0, 0, Math.PI * 2); ctx.fillStyle = g; ctx.fill();
      ctx.lineWidth = Math.max(1, W * 0.006); ctx.strokeStyle = 'rgba(26,19,17,.45)'; ctx.stroke();
      var lg = ctx.createLinearGradient(0, neckY - ry, 0, neckY + ry);
      lg.addColorStop(0, '#8d877c'); lg.addColorStop(1, '#d9d4cb');
      ctx.beginPath(); ctx.ellipse(W / 2, neckY + ry * 0.1, rx * 0.84, ry * 0.7, 0, 0, Math.PI * 2); ctx.fillStyle = lg; ctx.fill();
      ctx.strokeStyle = 'rgba(26,19,17,.35)'; ctx.stroke();
      ctx.beginPath(); ctx.ellipse(W / 2, neckY - ry * 0.28, rx * 0.2, ry * 0.16, 0, 0, Math.PI * 2); ctx.fillStyle = '#4a443c'; ctx.fill();
      ctx.beginPath(); ctx.ellipse(W / 2, neckY + ry * 0.12, rx * 0.17, ry * 0.3, 0, 0, Math.PI * 2); ctx.fillStyle = '#efebe4'; ctx.fill();
      ctx.strokeStyle = 'rgba(26,19,17,.5)'; ctx.stroke();
      ctx.beginPath(); ctx.ellipse(W / 2, neckY + ry * 0.12, rx * 0.06, ry * 0.11, 0, 0, Math.PI * 2); ctx.fillStyle = '#7b756b'; ctx.fill();
      /* base: chime tapers in, domed bottom edge */
      var bi = W * 0.06, by = H - ry * 0.75 - 1;
      ctx.beginPath();
      ctx.moveTo(0, lb - 1); ctx.lineTo(W, lb - 1);
      ctx.bezierCurveTo(W, lb + (by - lb) * 0.6, W - bi, by - (by - lb) * 0.2, W - bi, by);
      ctx.ellipse(W / 2, by, W / 2 - bi, ry * 0.75, 0, 0, Math.PI);
      ctx.bezierCurveTo(bi, by - (by - lb) * 0.2, 0, lb + (by - lb) * 0.6, 0, lb - 1);
      ctx.closePath(); ctx.fillStyle = g; ctx.fill();
      /* seams */
      ctx.lineWidth = Math.max(1, W * 0.005); ctx.strokeStyle = 'rgba(26,19,17,.4)';
      ctx.beginPath(); ctx.moveTo(0, lt); ctx.lineTo(W, lt); ctx.moveTo(0, lb); ctx.lineTo(W, lb); ctx.stroke();
      /* cylinder shading, only on the can */
      ctx.globalCompositeOperation = 'source-atop';
      var s = ctx.createLinearGradient(0, 0, W, 0);
      s.addColorStop(0, 'rgba(26,19,17,.5)'); s.addColorStop(.18, 'rgba(26,19,17,.1)'); s.addColorStop(.36, 'rgba(255,252,245,.22)');
      s.addColorStop(.5, 'rgba(255,252,245,0)'); s.addColorStop(.8, 'rgba(26,19,17,.12)'); s.addColorStop(1, 'rgba(26,19,17,.55)');
      ctx.fillStyle = s; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over';
    });
  };

  function mount() {
    [].forEach.call(document.querySelectorAll('[data-spin]'), function (el) {
      if (!el.__spin) el.__spin = new Spin(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
